import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button, Table, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { requestMappedCompanyName, requestCompanyNameSearch, requestSaveMappedCompanies } from "./action";
import * as CaseViewActions from "../View/action"
import { getMappedRatingData, getSearchedRatingData, setAgencyBody } from './helper'
import { toast } from "react-toastify";
import { RATING_AGENCIES } from './constants';
import { Preloading } from "../../../components/UI/Preloader/action";

class CompanyMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseData: [],
            companyNameOnAgency: {},
            ratingCheckboxData: {},
            companyNameList: {},
            companyNameSearch: "",
            crisilNewMappedName: null,
            icraNewMappedName: null,
            careNewMappedName: null,
            brickworkNewMappedName: null,
            irNewMappedName: null,
            acuiteNewMappedName: null,
            saveMappedCompanySuccess: null,
            saveMappedCompanyFailure: null
        };
    }

    componentDidMount() {
        this.props.getCaseDetails(this.props.match.params.caseNo);
    }

    componentDidUpdate(prevProps) {
        const { details } = this.props;
        if (details !== prevProps.details) {
            this.setState({ caseData: this.props.details.data });
        }

        if (this.props.saveMappedCompanySuccess !== prevProps.saveMappedCompanySuccess) {
            this.props.preloading(false);
            toast.success(
                <div>
                    <i className="fa fa-check"></i> Mapped Companies Saved Successfully.
               </div>
            );
        }

        if (this.props.saveMappedCompanyFailure !== prevProps.saveMappedCompanyFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i> Something went wrong, Please try again !
               </div>
            );
        }

        if (this.props.companyNameList !== prevProps.companyNameList) {
            if (this.props.companyNameList !== undefined) {
            if (this.props.companyNameList.data !== undefined) {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.companyNameList.data}
                    </div>,
                );
            }
        }
            this.props.preloading(false);
        }
    }

    handleCompanySearch = () => {
        if (this.state.companyNameSearch !== "" && this.state.companyNameSearch !== null) {
            let agencies = []
            agencies = setAgencyBody(this.state.ratingCheckboxData);
            if (agencies.shouldSearchInAcuite === true || agencies.shouldSearchInBrickwork === true || agencies.shouldSearchInCare === true || agencies.shouldSearchInCrisil === true || agencies.shouldSearchInIcra === true || agencies.shouldSearchInIR === true) {
                const requestBody = {
                    counterpartyId: this.state.caseData.counterpartyId,
                    companyName: this.state.caseData.counterpartyName,
                    searchName: this.state.companyNameSearch,
                    ...agencies
                }
                this.props.requestCompanyNameSearch(requestBody);
                this.props.preloading(true);
            }
            else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select atleast one agency
                    </div>
                );
            }
        }
        else {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please enter Company Name
                </div>
            );
        }
    }

    handleAgencyCheckboxchange = event => {
        let tempData = event.target.name;
        let ratingCheckbox = Object.assign({}, this.state.ratingCheckboxData);
        ratingCheckbox = {
            ...ratingCheckbox,
            [tempData]: event.target.checked,
        };

        this.setState(
            {
                ratingCheckboxData: ratingCheckbox
            }
        );
    };

    handleRadiochange = event => {
        const target = event.target;
        if (this.state[`${target.name}-${target.value}`] !== target.checked) {
            this.setState({
              [`${target.name}-${target.value}`]: target.checked
            });
          }

        let radioagency = event.target.name;
        let companyName = event.target.value;
        if (target.checked === true){
        if (radioagency == "CRISIL") {
            this.setState({ crisilNewMappedName: companyName })
        }
        else if (radioagency == "ICRA") {
            this.setState({ icraNewMappedName: companyName })
        }
        else if (radioagency == "CARE") {
            this.setState({ careNewMappedName: companyName })
        }
        else if (radioagency == "BRICKWORK") {
            this.setState({ brickworkNewMappedName: companyName })
        }
        else if (radioagency == "INDIARATINGS") {
            this.setState({ irNewMappedName: companyName })
        }
        else if (radioagency == "ACUITE") {
            this.setState({ acuiteNewMappedName: companyName })
        }
    }
    else{
        if (radioagency == "CRISIL") {
            this.setState({ crisilNewMappedName: null })
        }
        else if (radioagency == "ICRA") {
            this.setState({ icraNewMappedName: null })
        }
        else if (radioagency == "CARE") {
            this.setState({ careNewMappedName: null })
        }
        else if (radioagency == "BRICKWORK") {
            this.setState({ brickworkNewMappedName: null })
        }
        else if (radioagency == "INDIARATINGS") {
            this.setState({ irNewMappedName: null })
        }
        else if (radioagency == "ACUITE") {
            this.setState({ acuiteNewMappedName: null })
        }
    }
    }

    handleCompanyTextChange = event => {
        this.setState({ companyNameSearch: event.target.value });
    }

    handleCompanyNameSave = () => {
        let acuiteData = { agencyCompanyName: this.state.acuiteNewMappedName }
        let brickworkData = { agencyCompanyName: this.state.brickworkNewMappedName }
        let careData = { agencyCompanyName: this.state.careNewMappedName }
        let crisilData = { agencyCompanyName: this.state.crisilNewMappedName }
        let icraData = { agencyCompanyName: this.state.icraNewMappedName }
        let irData = { agencyCompanyName: this.state.irNewMappedName }
        let ratingData = { acuiteRating: acuiteData, brickworksRating: brickworkData, careRating: careData, crisilRating: crisilData, icraRating: icraData, irRating: irData }
        if (ratingData.acuiteRating.agencyCompanyName !== null || ratingData.brickworksRating.agencyCompanyName !== null || ratingData.careRating.agencyCompanyName !== null || ratingData.crisilRating.agencyCompanyName !== null || ratingData.icraRating.agencyCompanyName !== null || ratingData.irRating.agencyCompanyName !== null) {
            let ratingExistingData = getMappedRatingData(this.props.companyNameOnAgency);
            ratingData.acuiteRating.agencyCompanyName = ratingData.acuiteRating.agencyCompanyName === null ? ratingExistingData.acuiteAgencyCompanyName : ratingData.acuiteRating.agencyCompanyName;
            ratingData.brickworksRating.agencyCompanyName = ratingData.brickworksRating.agencyCompanyName === null ? ratingExistingData.brickworkAgencyCompanyName : ratingData.brickworksRating.agencyCompanyName;
            ratingData.careRating.agencyCompanyName = ratingData.careRating.agencyCompanyName === null ? ratingExistingData.careAgencyCompanyName : ratingData.careRating.agencyCompanyName;
            ratingData.crisilRating.agencyCompanyName = ratingData.crisilRating.agencyCompanyName === null ? ratingExistingData.crisilAgencyCompanyName : ratingData.crisilRating.agencyCompanyName;
            ratingData.icraRating.agencyCompanyName = ratingData.icraRating.agencyCompanyName === null ? ratingExistingData.icraAgencyCompanyName : ratingData.icraRating.agencyCompanyName;
            ratingData.irRating.agencyCompanyName = ratingData.irRating.agencyCompanyName === null ? ratingExistingData.irAgencyCompanyName : ratingData.irRating.agencyCompanyName;

            const requestBody = {
                counterpartyId: this.state.caseData.counterpartyId,
                ratingDataModel: ratingData
            }
            this.props.requestSaveMappedCompanies(requestBody);
            this.props.preloading(true);
        }
        else {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select company name
                </div>
            );
        }
    }

      handleClick = e => {
        const target = e.currentTarget;
    
        if (
          target.checked &&
          this.state[`${target.name}-${target.value}`] === target.checked
        ) {
          target.checked = false;
          target.click();
        }
      };

    render() {
        this.props.requestMappedCompanyName(this.state.caseData.counterpartyId);
        let ratingMappedData = getMappedRatingData(this.props.companyNameOnAgency)
        let searchedRatingData = getSearchedRatingData(this.state.caseData.counterpartyId, this.props.companyNameList)
        let crisilRadio;
        let icraRadio;
        let careRadio;
        let brickworkRadio;
        let irRadio;
        let acuiteRadio;
        if (ratingMappedData.crisilAgencyCompanyName !== "" && ratingMappedData.crisilAgencyCompanyName !== null)
        {
            crisilRadio = <tr><td><input type="radio" name="CRISIL" value="" onChange={this.handleRadiochange} onClick={this.handleClick}/>Remove Mapping</td></tr>
        }
        if (ratingMappedData.icraAgencyCompanyName !== "" && ratingMappedData.icraAgencyCompanyName !== null)
        {
            icraRadio = <tr><td><input type="radio" name="ICRA" value="" onChange={this.handleRadiochange} onClick={this.handleClick}/>Remove Mapping</td></tr>
        }
        if (ratingMappedData.careAgencyCompanyName !== "" && ratingMappedData.careAgencyCompanyName !== null)
        {
            careRadio = <tr><td><input type="radio" name="CARE" value="" onChange={this.handleRadiochange} onClick={this.handleClick}/>Remove Mapping</td></tr>
        }
        if (ratingMappedData.brickworkAgencyCompanyName !== "" && ratingMappedData.brickworkAgencyCompanyName !== null)
        {
            brickworkRadio = <tr><td><input type="radio" name="BRICKWORK" value="" onChange={this.handleRadiochange} onClick={this.handleClick}/>Remove Mapping</td></tr>
        }
        if (ratingMappedData.irAgencyCompanyName !== "" && ratingMappedData.irAgencyCompanyName !== null)
        {
            irRadio = <tr><td><input type="radio" name="INDIARATINGS" value="" onChange={this.handleRadiochange} onClick={this.handleClick}/>Remove Mapping</td></tr>
        }
        if (ratingMappedData.acuiteAgencyCompanyName !== "" && ratingMappedData.acuiteAgencyCompanyName !== null)
        {
            acuiteRadio = <tr><td><input type="radio" name="ACUITE" value="" onChange={this.handleRadiochange} onClick={this.handleClick}/>Remove Mapping</td></tr>
        }
        return (
            <Col>
                <div className="d-flex">
                    <h4 className="mr-auto p-2">{this.state.caseData.counterpartyName}</h4>
                </div>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle className="d-flex justify-content-between align-items-center">
                                    <span className="title">Mapped Company Names</span>
                                </CardTitle>
                                <Row>
                                    <Col sm="4">
                                        <span className="font-weight-bold">CRISIL</span>
                                    </Col>
                                    <Col sm="8">
                                        {ratingMappedData.crisilAgencyCompanyName}
                                    </Col>
                                    <Col sm="4">
                                        <span className="font-weight-bold">ICRA</span>
                                    </Col>
                                    <Col sm="8">
                                        {ratingMappedData.icraAgencyCompanyName}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="4">
                                        <span className="font-weight-bold">CARE</span>
                                    </Col>
                                    <Col sm="8">
                                        {ratingMappedData.careAgencyCompanyName}
                                    </Col>
                                    <Col sm="4">
                                        <span className="font-weight-bold">BRICKWORK</span>
                                    </Col>
                                    <Col sm="8">
                                        {ratingMappedData.brickworkAgencyCompanyName}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="4">
                                        <span className="font-weight-bold">INDIARATINGS</span>
                                    </Col>
                                    <Col sm="8">
                                        {ratingMappedData.irAgencyCompanyName}
                                    </Col>
                                    <Col sm="4">
                                        <span className="font-weight-bold">ACUITE</span>
                                    </Col>
                                    <Col sm="8">
                                        {ratingMappedData.acuiteAgencyCompanyName}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <br></br>

                <Card>
                    <CardBody>
                        <CardTitle>
                            <span className="title">Company Search</span>
                        </CardTitle>
                        <Row className="mb-2">
                            <Col className="col-sm-12">
                                <input type="text" name="CommpanyName" onChange={this.handleCompanyTextChange} placeholder="Enter Company Name" className="form-control" />
                            </Col>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleCompanySearch()} > Search </Button></Col>
                        </Row>
                        <br></br><br></br>
                        <Row>
                            {
                                RATING_AGENCIES.map((agency, index) => {
                                    return (
                                        <Col sm="4" key={index}>
                                            <label className="automation-container"><span>{agency}</span>
                                                <input type="checkbox" name={agency} disabled={false} checked={(this.state.ratingCheckboxData[agency] === true) ? true : false} onChange={this.handleAgencyCheckboxchange} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </CardBody>
                </Card>

                <br></br>
                <Card>
                    <CardBody>
                        <CardTitle>
                            <span className="title">Search Result</span>
                        </CardTitle>
                        <Row className="text-center text-primary ">
                            <Col>
                                {searchedRatingData.message}
                            </Col>
                        </Row>
                        <br></br>
                        <Row>
                            <Col sm="12">
                                <Table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                CRISIL
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(searchedRatingData.crisilList).map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="radio" name="CRISIL" value={searchedRatingData.crisilList[obj].string} onChange={this.handleRadiochange} onClick={this.handleClick} />{searchedRatingData.crisilList[obj].string} ({searchedRatingData.crisilList[obj].score})
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {crisilRadio}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col sm="12">
                                <Table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                ICRA
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(searchedRatingData.icraList).map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="radio" name="ICRA" value={searchedRatingData.icraList[obj].string} onChange={this.handleRadiochange} onClick={this.handleClick}/>{searchedRatingData.icraList[obj].string} ({searchedRatingData.icraList[obj].score})
                                                        </td>
                                                    </tr>
                                                )
                                            })                                            
                                        }
                                        {icraRadio}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <Table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                CARE
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(searchedRatingData.careList).map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="radio" name="CARE" value={searchedRatingData.careList[obj].string} onChange={this.handleRadiochange} onClick={this.handleClick}/>{searchedRatingData.careList[obj].string} ({searchedRatingData.careList[obj].score})
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {careRadio}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col sm="12">
                                <Table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                BRICKWORK
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(searchedRatingData.brickworkList).map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="radio" name="BRICKWORK" value={searchedRatingData.brickworkList[obj].string} onChange={this.handleRadiochange} onClick={this.handleClick}/>{searchedRatingData.brickworkList[obj].string} ({searchedRatingData.brickworkList[obj].score})
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {brickworkRadio}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm="12">
                                <Table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                INDIARATINGS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(searchedRatingData.irList).map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="radio" name="INDIARATINGS" value={searchedRatingData.irList[obj].string} onChange={this.handleRadiochange} onClick={this.handleClick}/>{searchedRatingData.irList[obj].string} ({searchedRatingData.irList[obj].score})
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {irRadio}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col sm="12">
                                <Table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>
                                                ACUITE
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(searchedRatingData.acuiteList).map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="radio" name="ACUITE" value={searchedRatingData.acuiteList[obj].string} onChange={this.handleRadiochange} onClick={this.handleClick}/>{searchedRatingData.acuiteList[obj].string} ({searchedRatingData.acuiteList[obj].score})
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        {acuiteRadio}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <Row className="justify-content-center">
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleCompanyNameSave()} > Save </Button></Col>
                        </Row>
                    </CardFooter>
                </Card>

            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    details: state.section.caseDetails,
    caseDetailsError: state.section.caseDetailsError,
    companyNameOnAgency: state.ratingCompanyMap.companyNameOnAgency,
    companyNameList: state.ratingCompanyMap.companyNameList,
    saveMappedCompanySuccess: state.ratingCompanyMap.saveMappedCompanySuccess,
    saveMappedCompanyFailure: state.ratingCompanyMap.saveMappedCompanyFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    getCaseDetails: id => { dispatch(CaseViewActions.getCaseDetails(id)); },
    requestMappedCompanyName: id => { dispatch(requestMappedCompanyName(id)) },
    requestCompanyNameSearch: data => { dispatch(requestCompanyNameSearch(data)) },
    requestSaveMappedCompanies: data => { dispatch(requestSaveMappedCompanies(data)) },
    preloading: isPreloading => { dispatch(Preloading(isPreloading)); }
});
export default CompanyMap = connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyMap)